import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/ui-ux.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Innovative UI/UX Design Solutions"
				breadcrumbText="UI/UX Design"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}